import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class ToasterService {
  show = signal(false);
  message = signal<string | null>(null);
  type = signal<'success' | 'error'>('success');

  open(message: string, type: 'success' | 'error' = 'success'):void {
    this.message.set(message);
    this.type.set(type);
    this.show.set(true);
  }

  close():void {
    this.show.set(false);
  }
}